import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ValidationCallbackData } from 'devextreme-angular/common';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { AuthService } from '../../services';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-change-passsword-form',
  templateUrl: './change-password-form.component.html',
  styleUrls: ['./change-password-form.component.scss']
})
export class ChangePasswordFormComponent implements OnInit {
  loading = false;
  formData: any = {};
  recoveryCode: string = '';
  user:any;
  
  constructor(private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.recoveryCode = params.get('recoveryCode') || '';
    });

    this.authService.subscribeUser().subscribe((user) => {
      this.user = user;
    });
  }

  async onSubmit(e: Event) {
    //this.recoveryCode dolu değil ise şifre sıfırlama bağlantısı ile değil şifre sıfırlama ekranından geliyor demektir
    if(!this.recoveryCode)
      this.recoveryCode="null"
    e.preventDefault();
    const { password } = this.formData;
    this.loading = true;

    const result = await this.authService.changePassword(password, this.recoveryCode);
    this.loading = false;
    if(result.isOk && this.recoveryCode == "null"){
      this.notificationService.show('Şifreniz başarı ile değiştirildi.')
      return
    }
    else
      this.notificationService.show('Şifreniz değiştirildi. Giriş yapabilirsiniz.')

    if (result.isOk) {
      this.router.navigate(['/login-form']);
    } else {
      notify(result.message, 'error', 2000);
    }
  }

  passwordContainsLetterAndNumber = (e: any) => {
    const value = e.value;
    const containsLetter = /[a-zA-Z]/.test(value);
    const containsNumber = /[0-9]/.test(value);

    return containsLetter && containsNumber;
  }

  passwordLengthCheck = (e: any) => {
    const value = e.value;
    return value.length >= 6;
  }

  confirmPassword = (e: ValidationCallbackData) => {
    return e.value === this.formData.password;
  }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule
  ],
  declarations: [ChangePasswordFormComponent],
  exports: [ChangePasswordFormComponent]
})
export class ChangePasswordFormModule { }
